import { render, staticRenderFns } from "./inscription-view-page.vue?vue&type=template&id=625886fa&scoped=true&"
import script from "./inscription-view-page.vue?vue&type=script&lang=js&"
export * from "./inscription-view-page.vue?vue&type=script&lang=js&"
import style0 from "./inscription-view-page.vue?vue&type=style&index=0&id=625886fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625886fa",
  null
  
)

export default component.exports